import {Promise} from "es6-promise";
import {cookieService} from "modules/services/CookieService";

declare var initStore:any;
declare var window:any;


export class UserInfo {
    private userId: string;
    private userName: string;

    constructor() {
        let userInfoCookie = cookieService.getQueryStringObject('userInfo');
        if(userInfoCookie) {
            this.userId = userInfoCookie['ID'];
            this.userName = userInfoCookie['userName'];
        }
    }

    ready(): Promise<UserInfo> {
        return Promise.resolve(window.isSubscriber);
    }


    public getUserId():string {
        return this.userId;
    }

    /**
     * @deprecated
     */
    public isCROSubscriber():boolean {
        console.warn("DEPRECATED Method");
        return window.isSubscriber;
    }

    /**
     * @returns {"es6-promise".Promise<boolean>}
     */
    hasSubscription():Promise<boolean> {
        return Promise.resolve(window.isSubscriber);
    }
}

let userInfo = new UserInfo();
export {userInfo}



// WEBPACK FOOTER //
// ./resources/modules/models/UserInfo.ts